import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import brandIllustration from '../assets/brand.png';

const AboutSection = () => {
  return (
    <Box
      sx={{
        py: 10,
        background: `linear-gradient(135deg, #FFF 50%, #F3F3F3 50%)`,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ x: -50, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <Typography variant="h3" sx={{ mb: 2 }}>
                About MindMapper AI
              </Typography>
              <Typography variant="body1" sx={{ mb: 4 }}>
                MindMapper AI is a next-generation platform dedicated to helping you 
                explore your inner world. Our AI-driven analysis tools and personalized 
                meditation sessions empower you to track and understand your dream life 
                and mental well-being.
              </Typography>
              <Typography variant="body1">
                Whether you’re a curious dreamer or a seasoned mindfulness practitioner, 
                MindMapper AI provides an immersive and intuitive experience to guide you 
                on your journey.
              </Typography>
            </motion.div>
          </Grid>
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ x: 50, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <Box
                component="img"
                src={brandIllustration}
                alt="About MindMapper AI"
                sx={{ width: '100%', borderRadius: 10, boxShadow: 7 }}
              />
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default AboutSection;
